import React from "react";

export default ({ mandatory }) => {
  if (!mandatory) {
    return null;
  }
  return <sup style={{ color: "red", fontSize: 16 }}>*</sup>;
};
